<nz-card>
  <div nz-row style="display: flex; justify-content: space-between;">
    <div class="main-column">
      <leap-media-card *ngIf="video" [media]="video" [type]="'videos'"></leap-media-card>
      <div class="long-description" *ngIf="longDescription" [innerHTML]="longDescription | htmlBypass"></div>
      <br>
      <div *ngIf="sellerRole">
        <label>About the Seller</label>
        <div [innerHTML]="sellerRole | htmlBypass"></div>
        <br>
        <div *ngIf="sellerAccreditationStatus" [innerHTML]="sellerAccreditationStatus | htmlBypass"></div>
      </div>
      <br>
      <div class="trainer-requirements" *ngIf="trainerRequirements">
        <label>Trainer Requirements</label>
        <div [innerHTML]="trainerRequirements | htmlBypass"></div>
      </div>
      <br>
      <div class="ip-statement" *ngIf="ipStatement" [innerHTML]="ipStatement | htmlBypass"></div>
    </div>
    <div *leapHasGroup="['buyer']">
      <div class="right-column" *ngIf="restricted && !hasAccess">
        <leap-license-agreement [segmentsMapper]="segmentsMapper"></leap-license-agreement>
      </div>
    </div>
  </div>
</nz-card>
